import { InjectionToken } from '@angular/core';

export const AUTH_ENABLED = new InjectionToken<any>('AUTH_ENABLED');

export const RESOLVED_TOKEN = new InjectionToken<any>('RESOLVED_TOKEN');
